import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Center, Container } from '@mantine/core';

export const Route = createFileRoute('/_public')({ component: PublicLayout });

function PublicLayout() {
  return (
    <Center mih="100vh">
      <Container size="md" w="100%" py="xl">
        <Outlet />
      </Container>
    </Center>
  );
}
